import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';
import {
    query,
    setSearchQuery,
    toggleShowFullForm,
    handleKeyDown,
    handleClickSearch,
} from '../Actions/QuickSearch.action';
import usePrevious from '@react-hook/previous';
import { debounce } from 'lodash-es';

// debouncing function to 200ms so we don't send query request on every key stroke
const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);

const QuickSearch = () => {
    const {
        query,
        result,
        showResult,
        showFullForm,
        selectedItem,
    } = useSelector((state) => state.quickSearch);
    const [lastClickedNode, setLastClickedNode] = useState(null);
    const searchUrl =
        window.__litium.quickSearchUrl +
        (query.length > 0 ? `?q=${query}` : '');
    const searchContainer = useRef(null);
    const searchInput = useRef(null);
    const dispatch = useDispatch();
    const previousSelectedItem = usePrevious(selectedItem);

    const clickHandler = useCallback((event) => {
        setLastClickedNode(event.target);
    }, []);
    useEffect(() => {
        // listen for click event to hide the search when clicking outside
        window.addEventListener('mousedown', clickHandler);
        return () => window.removeEventListener('mousedown', clickHandler);
    }, [clickHandler]);

    useEffect(() => {
        // set query value if it is avaialble in the Url
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            dispatch(setSearchQuery(query));
        }
    }, [dispatch]);

    useEffect(() => {
        if (selectedItem !== previousSelectedItem) {
            const el = document.querySelector(
                '.quick-search-result__item--selected'
            );
            el &&
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                });
        }
    }, [selectedItem, previousSelectedItem]);

    return (
        <div className="quick-search" role="search" ref={searchContainer}>
            {/*<a*/}
            {/*    className="quick-search__link--block"*/}
            {/*    rel="nofollow"*/}
            {/*    href="#"*/}
            {/*    title={translate('general.search')}*/}
            {/*    onClick={(e) => {*/}
            {/*        e.preventDefault();*/}
            {/*        dispatch(toggleShowFullForm());*/}
            {/*        setTimeout(() => {*/}
            {/*            searchInput.current && searchInput.current.focus();*/}
            {/*        }, 0);*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <i className="quick-search__icon"></i>*/}
            {/*    <span className="quick-search__title hide">*/}
            {/*        {translate('general.search')}*/}
            {/*    </span>*/}
            {/*</a>*/}
            <div
                className={`quick-search__form ${
                    showFullForm ? 'quick-search__form--force-show' : ''
                }`}
                role="search"
            >
                <i
                    className="quick-search__icon"
                    onClick={(e) => dispatch(toggleShowFullForm())}
                ></i>
                <input
                    className="quick-search__input"
                    type="search"
                    placeholder={translate('general.search')}
                    autoComplete="off"
                    value={decodeURIComponent(query)}
                    onChange={(event) => {
                        const text = encodeURIComponent(event.target.value);
                        dispatch(setSearchQuery(text));
                        debouncedQuery(dispatch, text);
                    }}
                    onKeyDown={(event) =>
                        dispatch(handleKeyDown(event, { searchUrl }))
                    }
                    ref={searchInput}
                    onBlur={() => {
                        if (
                            searchContainer.current &&
                            !searchContainer.current.contains(lastClickedNode)
                        ) {
                            showFullForm && dispatch(toggleShowFullForm());
                        }
                    }}
                />
                <button
                    className="quick-search__submit-button"
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        dispatch(handleClickSearch({ searchUrl }));
                    }}
                >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6684 4.95689C16.8688 7.81945 16.4071 11.0514 14.3756 13.3599L17.7922 16.7765C18.0693 17.0535 18.0693 17.5152 17.7922 17.7922C17.5152 18.0693 17.0535 18.0693 16.7765 17.7922L13.3599 14.3756C9.94328 17.2382 4.77221 16.8688 1.90965 13.3599C-0.952904 9.94328 -0.583542 4.77221 2.9254 1.90965C6.43434 -0.952904 11.5131 -0.583543 14.3756 2.9254C14.9297 3.47944 15.3914 4.21817 15.6684 4.95689ZM5.51094 1.90965C2.09434 3.3871 0.524545 7.35775 1.90965 10.7743C3.3871 14.1909 7.35775 15.7607 10.7744 14.3756C11.6054 14.0063 12.2518 13.5446 12.8982 12.8982C15.4837 10.2203 15.4837 5.97264 12.8982 3.3871C10.959 1.35561 8.09647 0.801567 5.51094 1.90965Z" fill="#212121" />
                    </svg>
                </button>
                {showResult && (
                    <QuickSearchResult
                        result={result}
                        selectedItem={selectedItem}
                        searchUrl={searchUrl}
                    />
                )}
            </div>
        </div>
    );
};

export default QuickSearch;
